import React from "react";
import { Skeleton } from "../ui/skeleton";

const TableSkeleton = () => {
  return (
    <>
      <div className="w-screen h-screen p-6 bg-color1">
        <div className="h-28 mb-10 w-full bg-color2"></div>
        <div className="grid grid-cols-3 grid-rows-1 h-full">
            {/* Left Side */}
          <div className="col-span-2 w-full">
          
            {/* Buttons */}
            <div>  
              <Skeleton className="flex gap-4">
                <div className="h-8 w-28 bg-color2 rounded"></div>
                <div className="h-8 w-24 bg-color2 rounded"></div>
                <div className="h-8 w-32 bg-color2 rounded"></div>
              </Skeleton>
              <Skeleton className="mt-4 flex gap-4">
                <div className="h-8 w-28 bg-color2 rounded"></div>
                <div className="h-8 w-24 bg-color2 rounded"></div>
                <div className="h-8 w-32 bg-color2 rounded"></div>
                <div className="h-8 w-32 bg-color2 rounded"></div>
                <div className="h-8 w-32 bg-color2 rounded"></div>
              </Skeleton>
            </div>

            {/* Staff list */}
            <div>
              <Skeleton className="mt-10 w-full h-full flex flex-wrap gap-2">
                {Array.from({ length: 6 }).map((_, i) => (
                  <div
                    key={i}
                    className="h-40 w-40 bg-color2 rounded-md flex flex-col justify-center items-center"
                  >
                    <div className="h-4 w-20 bg-color3 rounded mb-2"></div>
                    <div className="h-3 w-16 bg-color3 rounded"></div>
                  </div>
                ))}
              </Skeleton>
              <Skeleton className=" mt-10 w-full flex flex-wrap gap-2">
                {Array.from({ length: 6 }).map((_, i) => (
                  <div
                    key={i}
                    className="h-40 w-40 bg-color2 rounded-md flex flex-col justify-center items-center"
                  >
                    <div className="h-4 w-20 bg-color3 rounded mb-2"></div>
                    <div className="h-3 w-16 bg-color3 rounded"></div>
                  </div>
                ))}
              </Skeleton>
            </div>
          </div>

          {/* Right Side */}
          <div className="h-[calc(100vh-220px)] col-span-1 bg-color2 rounded-md p-4 mb-10">
            {/* User Info */}
            <div className="flex justify-between">
              <div className="h-[20px] w-32 bg-color1 rounded mt-4"></div>
              <div className="flex gap-4">
                <div className="h-[20px] w-16 bg-color1 rounded mt-4"></div>
                <div className="h-[20px] w-16 bg-color1 rounded mt-4"></div>
              </div>
            </div>

            {/* Action Buttons */}
            <div className="mt-10">
              {Array.from({ length: 6 }).map((_, i) => (
                <div key={i} className="flex justify-between gap-2 mt-4">
                  <div className="flex gap-2">
                    <div className="h-8 w-8 rounded-full bg-color1"></div>
                    <div className="h-8 w-20 bg-color1 rounded"></div>
                  </div>
                  <div className="h-8 w-20 bg-color1 rounded"></div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TableSkeleton;
